export default "__VITE_ASSET__C8I09RU$__"